/**
 * Controlled list from Timeline AuthorizedCommunicationMethod.
 * Wire values are the display strings the create/update APIs accept.
 */
export const AUTHORIZED_COMMUNICATION_METHODS = [
  'Email (Link)',
  'Voice Call',
  'Knostos Engage Messaging',
] as const;

export type AuthorizedCommunicationMethod = typeof AUTHORIZED_COMMUNICATION_METHODS[number];

export interface TaskAiFields {
  objective?: string;
  critical_data?: string;
  data_sources?: string;
  authorized_communication_methods?: AuthorizedCommunicationMethod[];
}

export function emptyTaskAiFields(): TaskAiFields {
  return {
    objective: '',
    critical_data: '',
    data_sources: '',
    authorized_communication_methods: [],
  };
}
